
import AuthorizePlans from './components/authorize-plans.vue';
import AuthorizePermission from './components/authorize-permission.vue';
import AuthorizeSubscribeTime from './components/authorize-subscribe-time.vue';
import AuthorizeSubscribeType from './components/authorize-subscribe-type.vue';
import AuthorizePlanType from './components/authorize-plan-type.vue';
import { GrantType, PlanNormal } from '@/common/permission';

export default {
  components: {
    AuthorizePlans: AuthorizePlans,
    AuthorizePermission: AuthorizePermission,
    AuthorizeSubscribeTime: AuthorizeSubscribeTime,
    AuthorizeSubscribeType: AuthorizeSubscribeType,
    AuthorizePlanType: AuthorizePlanType
  },
  props: {
    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    formValue: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      default: 'create'
    }
  },
  data: function data() {
    return {
      GrantType: GrantType,
      PlanNormal: PlanNormal
    };
  }
};